import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 状态
    LINKS_STATUS: computed(() => (
      store.state.label.data.LINKS?.LINKS_STATUS
    )),
    // 展示位置
    LINKS_SHOW_POSITION: computed(() => (
      store.state.label.data.LINKS?.LINKS_SHOW_POSITION
    )),
    // 打开方式
    LINKS_TARGET: computed(() => (
      store.state.label.data.LINKS?.LINKS_TARGET
    )),
    // 排序方式
    LINKS_SORT: computed(() => (
      store.state.label.data.LINKS?.LINKS_SORT
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    showName,
    ...computedData
  }
}
